




























import { Watch, Component, Prop, Vue, Inject } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { ActionType, ReferralStatus } from '@/api/types'

@Component
export default class ConfirmReferralStatusModal extends Vue {
    @Prop({ required: true }) readonly referral!: Referral
    @Prop({ type: Boolean, default: false }) value!: boolean
    @Prop() readonly status!: ReferralStatus
    @Prop() readonly statusReasonResourceId!: string

    visible: boolean = false
    loading: boolean = false

    @Watch('value')
    onValueChanged(): void {
        this.visible = this.value
    }

    @Watch('visible')
    onVisibleChanged(): void {
        this.$emit('input', this.visible)
    }
}
